<script setup lang="ts">
import { defineProps, defineModel } from "vue";

type Props = {
  title?: string;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  height?: string;
};

defineProps<Props>();

const textModel = defineModel<string>({ required: true });
</script>

<template>
  <div>
    <div>
      <h4
        class="text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-medium pb-[6px]"
      >
        {{ title }}
      </h4>
      <textarea
        v-model="textModel"
        :placeholder="placeholder"
        class="p-3 mb-1 rounded-primary-radius border resize-none w-full outline-none bg-[#F9F8F6] text-black text-base leading-[26px] tracking-[0.01rem] font-medium placeholder:text-[#898790]"
        :class="`${height ? height : 'h-[108px]'}
          ${isError ? 'border-[#ED857F]' : ''} 
          ${!isError && !textModel ? 'border-[#E3E1EA]' : ''} 
          ${textModel && textModel.length > 0 ? 'border-[#393840]' : ''} `"
      />
      <div class="flex gap-1 items-center" v-if="isError">
        <img src="@/assets/warning-red.svg" alt="Warning" />
        <span class="text-[#ed857f] text-sm">{{ errorMessage }}</span>
      </div>
    </div>
  </div>
</template>
